import { withStyles } from '@material-ui/core';

import PushNotificationDevicePreview from './component';
import styles from './styles';

export default withStyles(styles)(PushNotificationDevicePreview);
